import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import React, { Fragment, useEffect, useMemo, useState } from "react";
import { Modal } from "react-bootstrap";
import { BsPrinter } from "react-icons/bs";
import { GoDownload } from "react-icons/go";
import { useDispatch, useSelector } from "react-redux";
import { httpAdmin } from "../../../Apis/commonApis";
import { ShowSwal } from "../../../utils/alertSwal";
import { formatDate } from "../../../utils/CommonFunctions";
import datechangeHandler from "../../../utils/datechangehandler";
import { getClientbyId } from "../../../redux-toolkit/reducer/carePlanReducer";
import { useLocation, useParams } from "react-router-dom";
import { currentCareSiteId } from "../../../redux-toolkit/reducer/switchSites";
import {
  aboutMeDataLabelValues,
  additionalPlanLabelValues,
  advanceProfileDataLabelKeyVals,
  basicProfileDataLabelKeyVals,
  ContingencyDataLabelValues,
  formulationDataLabelValues,
} from "../CareplanTemplates/CarePlanConstants";
import { categoryIcons } from "../../../constants/constants";
import { getClientCarePlanPdf } from "../../../redux-toolkit/reducer/clientCarePlanReducer";
import LoadingBtn from "../../../components/Toggle_Button/LoadingBtn";

const PreviewCarePlan = ({ open, handleClose }) => {
  const dispatch = useDispatch();

  const { clientProfileData, downlaodCarePlan } = useSelector(
    (state) => state.carePlanReducer
  );
  const { clientCarePlans, carePlanCategories, administrativeCarePlans } =
    useSelector((state) => state?.clientCarePlanReducer);

  const { currentCareSiteData } = useSelector(
    (state) => state.caresiteDataReducer
  );

  const param = useParams();

  const [companyLogo, setCompanyLogo] = useState("");
  const [loading, setLoading] = useState(false);

  const location = useLocation();
  const clientId = location.state?.clientId;

  const userData = JSON.parse(localStorage.getItem("userData"));
  const currentCareHome =
    userData?.subscriptionPlanData &&
    userData?.subscriptionPlanData.find(
      (carehome) => carehome._id === currentCareSiteId
    );

  useEffect(() => {
    dispatch(getClientbyId({ clientId: clientId, currentCareSiteId }));
  }, []);

  useEffect(() => {
    if (currentCareSiteData?.logo) {
      converToBase64(`${currentCareSiteData?.logo}`);
      // imageUrlToBase64(clientProfileData?.image).then((base64Image) => {
      //     setClientImage(base64Image);
      //   })
      //   .catch((error) => {
      //     // Handle the error appropriately
      //   });
    }
  }, [currentCareSiteData]);

  const converToBase64 = async (url) => {
    const body = { url };
    // const response = await axios.get(url, { responseType: 'arraybuffer' });
    // const imageData = Buffer.from(response.data).toString('base64');
    // setCompanyLogo(imageData);
    const res = await httpAdmin(`convertImageUrltoBase64`, "post", body, null);
    if (res.status) {
      setCompanyLogo(res.data);
    }
  };

  const filteredDownlaodCarePlan = useMemo(() => {
    const addPlansToCategory = carePlanCategories.map((item) => {
      const catPlans =
        item.categoryName === "Administrative"
          ? administrativeCarePlans
          : clientCarePlans.filter(
              (elem) => elem.carePlanCategoryId === item._id
            );
      return {
        ...item,
        template: catPlans,
      };
    });
    return addPlansToCategory;
  }, [carePlanCategories, clientCarePlans]);

  const saveToDownloads = (type) => {
    if (!loading) {
      setLoading(true);
      const input = document.getElementById("pagetoDownload");
      html2canvas(input, { proxy: clientProfileData.image, scrollY: 0 })
        .then((canvas) => {
          const image = { type: "jpeg", quality: 0.98 };
          const margin = [0.6, 0.5];
          const filename = "myfile.pdf";

          var imgWidth = 8.5;
          var pageHeight = 11;

          var innerPageWidth = imgWidth - margin[0] * 2;
          var innerPageHeight = pageHeight - margin[1] * 2;

          // Calculate the number of pages.
          var pxFullHeight = canvas.height;
          var pxPageHeight = Math.floor(canvas.width * (pageHeight / imgWidth));
          var nPages = Math.ceil(pxFullHeight / pxPageHeight);

          // Define pageHeight separately so it can be trimmed on the final page.
          var pageHeight = innerPageHeight;

          // Create a one-page canvas to split up the full image.
          var pageCanvas = document.createElement("canvas");
          var pageCtx = pageCanvas.getContext("2d");
          pageCanvas.width = canvas.width;
          pageCanvas.height = pxPageHeight;

          // Initialize the PDF.
          var pdf = new jsPDF("p", "in", [8.5, 11]);

          for (var page = 0; page < nPages; page++) {
            // Trim the final page to reduce file size.
            if (page === nPages - 1 && pxFullHeight % pxPageHeight !== 0) {
              pageCanvas.height = pxFullHeight % pxPageHeight;
              pageHeight =
                (pageCanvas.height * innerPageWidth) / pageCanvas.width;
            }

            // Display the page.
            var w = pageCanvas.width;
            var h = pageCanvas.height;
            pageCtx.fillStyle = "white";
            pageCtx.fillRect(0, 0, w, h);
            pageCtx.drawImage(canvas, 0, page * pxPageHeight, w, h, 0, 0, w, h);

            // Add the page to the PDF.
            if (page > 0) pdf.addPage();
            // debugger;
            var imgData = pageCanvas.toDataURL(
              "image/" + image.type,
              image.quality
            );
            pdf.addImage(
              imgData,
              image.type,
              margin[1],
              margin[0],
              innerPageWidth,
              pageHeight
            );
          }

          if (type === "download") {
            pdf.save();
            setLoading(false);
          } else {
            const savepdftobase64format = new Blob([pdf.output("blob")], {
              type: "application/pdf",
            });
            savetocareplan(savepdftobase64format);
          }
        })
        .catch((error) => {
          setLoading(false);
          ShowSwal(false, error.message ?? "Something went wrong!");
        });
    }
  };

  const savetocareplan = async (pdfFile) => {
    let urlID = JSON.parse(localStorage.getItem("userData"));
    const data = new FormData();
    data.append("pdfLink", pdfFile, "careplan.pdf");
    data.append("adminId", urlID._id);
    data.append("careHomeId", currentCareSiteId);
    data.append("clientId", clientId);
    data.append("createdBy", `${urlID.firstName?.trim()} ${urlID?.lastName}`);

    const result = await httpAdmin(
      `createClientCarePlanPdf`,
      "POST",
      data,
      "formdata"
    );
    setLoading(false);
    ShowSwal(result.status, result.message);
    if (result.status) {
      dispatch(
        getClientCarePlanPdf({
          adminId: urlID?._id,
          currentCareSiteId,
          clientId: clientId,
        })
      );
      handleClose();
    }
  };

  // console.log(clientProfileData, "clientProfileData");

  return (
    <Modal className="viewModal" show={open} size="xl" onHide={handleClose}>
      <Modal.Header>
        <Modal.Title>
          <span></span>
          <div className="d-flex">
            <div className="iconDownLoad me-4">
              <span>
                <BsPrinter />
              </span>
              <span>
                <GoDownload
                  className="curser_point"
                  onClick={() => {
                    saveToDownloads("download");
                  }}
                />
              </span>
            </div>
            <button
              style={{ minWidth: "125px" }}
              className="btn"
              onClick={() => saveToDownloads("save")}
            >
              {loading ? (
                <LoadingBtn style={{ width: "16px", height: "16px" }} />
              ) : (
                "Create Care Plan"
              )}
            </button>
            <button className="btn" onClick={handleClose}>
              Close
            </button>
          </div>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div id="pagetoDownload" className="position-relative">
          <div className="container mt-3">
            <div className="row align-items-center mb-4">
              <div className="col-md-6 mb-3">
                <img
                  alt=""
                  src={
                    `data:image/png;base64,${companyLogo}` ??
                    `/admin/images/companyLogo.svg`
                  }
                  style={{ height: companyLogo ? "35px" : "40px" }}
                />
              </div>
              <div className="col-md-6 text-end mb-1">
                <p className="mb-0">
                  Care Plan &nbsp;
                  {currentCareHome?.careSiteName}
                </p>
              </div>
              <div className="col-md-12 textfont">
                <p>
                  Date:{" "}
                  {datechangeHandler(
                    new Date()
                    // clientProfileData?.carePlanUpdateDate ??
                  )}
                </p>
              </div>
              <div className="col-md-12 textfont">
                <p>
                  Created By: {`${userData.firstName} ${userData.lastName}`}{" "}
                </p>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12 mb-2">
                <h5 className="fontSize">Client Details</h5>
              </div>
              <div className="col-md-5 col-lg-5 col-xl-5 col-sm-12">
                <ul className="details_list">
                  {basicProfileDataLabelKeyVals?.map((keyValObj) => {
                    const dataValue = clientProfileData?.[keyValObj.value];
                    return dataValue ? (
                      <li key={keyValObj.value}>
                        <strong>{keyValObj.label}</strong>
                        <span>
                          {keyValObj.date
                            ? formatDate(dataValue)
                            : dataValue?.trim()}
                        </span>
                      </li>
                    ) : (
                      <></>
                    );
                  })}
                </ul>
              </div>
              <div className="col-lg-1"></div>
              <div className="col-md-4 col-lg-4 col-xl-4 col-sm-12">
                <ul className="details_list">
                  {advanceProfileDataLabelKeyVals?.map((keyValObj) => {
                    const dataValue = clientProfileData?.[keyValObj.value];
                    return dataValue ? (
                      <li key={keyValObj.value}>
                        <strong>{keyValObj.label}</strong>
                        <span>
                          {keyValObj.date ? formatDate(dataValue) : dataValue}
                        </span>
                      </li>
                    ) : (
                      <></>
                    );
                  })}
                </ul>
              </div>
              <div className="col-md-2">
                <div className="profile_img">
                  <img src={clientProfileData?.image} alt="client" />
                </div>
              </div>

              <div className="col-md-12 mb-2 mt-5">
                <h5 className="fontSize">Consent</h5>
              </div>
              <div className="col-md-5 col-lg-5 col-xl-5 col-sm-12">
                <ul className="details_list">
                  <li>
                    <strong>Mental Capacity to Consent</strong>
                    <span>
                      {clientProfileData?.consentMentalCapacity || "-"}
                    </span>
                  </li>
                  <li>
                    <strong>Power of Attorney in place</strong>
                    <span>{clientProfileData?.consentPOA || "-"}</span>
                  </li>
                  <li>
                    <strong>Authorized Person</strong>
                    {clientProfileData?.authrisedPerson
                      ?.map(({ name }) => name)
                      ?.join(",") || "-"}
                  </li>
                  <li>
                    <strong>Advanced Directive</strong>
                    <span>{clientProfileData?.advance_Directive || "-"}</span>
                  </li>
                </ul>
              </div>
              <div className="row">
                <div className="col-md-12 my-2">
                  <h5 className="fontSize">About me</h5>
                </div>
                {aboutMeDataLabelValues.map((keyValObj) => {
                  const dataValue = clientProfileData?.[keyValObj.value];
                  return dataValue ? (
                    <Fragment key={keyValObj.value}>
                      <h5 className="fontSize mb-0">{keyValObj.label}</h5>
                      <TextContentBox text={dataValue || "-"} mb={2} />
                    </Fragment>
                  ) : (
                    <Fragment key={keyValObj.value}></Fragment>
                  );
                })}
              </div>

              {clientProfileData?.medical_Conditions?.length > 0 && (
                <Fragment>
                  <div className="col-md-12 mb-2 mt-5">
                    <h5 className="fontSize">Medical Condition & Allergies</h5>
                  </div>
                  <div className="col-md-12">
                    <table className="popupTbleList table">
                      <thead>
                        <tr>
                          <th>Name</th>
                          <th>Type</th>
                          <th>Start Date</th>
                          <th>Diagnosed by</th>
                        </tr>
                      </thead>
                      <tbody>
                        {clientProfileData?.medical_Conditions?.map(
                          (condition) => {
                            return (
                              <tr key={condition?._id}>
                                <td>{condition?.name}</td>
                                <td>{condition?.type}</td>
                                <td>{formatDate(condition?.start_Date)}</td>
                                <td>{condition?.diagnosedBy}</td>
                              </tr>
                            );
                          }
                        )}
                      </tbody>
                    </table>
                  </div>
                </Fragment>
              )}

              {clientProfileData?.medication?.length > 0 && (
                <Fragment>
                  <div className="col-md-12 mb-3 mt-5">
                    <h5 className="fontSize">Medicines</h5>
                  </div>
                  <div className="col-md-12">
                    <table className="popupTbleList table careTemplateTable">
                      <thead>
                        <tr>
                          <th>Name</th>
                          <th>PRN</th>
                          <th>Start Date</th>
                          <th>Dosage</th>
                          <th>Frequency</th>
                          <th>Time</th>
                          <th>Meal Consideration</th>
                        </tr>
                      </thead>
                      <tbody>
                        {clientProfileData?.medication?.map((medic) => {
                          return (
                            <tr key={medic?._id}>
                              <td>{medic?.NM}</td>
                              <td>{medic?.prn}</td>
                              <td>{formatDate(medic?.startDate)}</td>
                              <td>
                                {medic?.strengthDose} {medic?.doseAmount}
                              </td>
                              <td>{medic?.frequency}</td>
                              <td>{medic?.schedule}</td>
                              <td>{medic?.mealConsideration}</td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                </Fragment>
              )}

              <div className="col-md-12 mb-3 mt-5">
                <h5 className="fontSize">Brief Background</h5>
              </div>
              <div className="col-md-12">
                <div className="row cont_list">
                  <div className="col">
                    <strong className="fontSize">
                      {clientProfileData?.brief}
                    </strong>
                  </div>
                </div>
              </div>
            </div>

            {filteredDownlaodCarePlan?.map((categoryplan) => {
              const categoryIcon = categoryIcons[categoryplan.categoryName];
              if (categoryplan?.categoryType === "Administrative") {
                return (
                  <>
                    {categoryplan?.template?.length > 0 && (
                      <Fragment>
                        <hr></hr>
                        <div className="row">
                          <div className="col-md-12 mb-2">
                            <h5 className="text-dark fontSize">
                              <img className="me-2" alt="" src={categoryIcon} />
                              Administrative
                              {/* {categoryplan?.categoryType} */}
                            </h5>
                          </div>

                          {categoryplan?.template?.map((cplan) => {
                            if (cplan?.carePlanType === "Formulation") {
                              return (
                                <Fragment>
                                  <h5 className="fontSize mt-3">Formulation</h5>
                                  <h5 className="fontSize mt-3">
                                    {" "}
                                    {cplan?.TemplateName}
                                  </h5>

                                  <p
                                    className="fontsmallText mb-0"
                                    style={{ fontSize: "14px" }}
                                  >
                                    Updated:{" "}
                                    {datechangeHandler(cplan?.last_update_date)}
                                  </p>
                                  <p
                                    className="fontsmallText"
                                    style={{ fontSize: "14px" }}
                                  >
                                    Updated By: {cplan?.updated_by}
                                  </p>

                                  <div className="col-md-8 right">
                                    {formulationDataLabelValues?.map(
                                      (valObj) => {
                                        const fieldVal = cplan?.[valObj?.value];
                                        const isDateField =
                                          valObj.label.includes("date") ||
                                          valObj.label.includes("Date");
                                        return (
                                          <div
                                            key={valObj?.value}
                                            style={{
                                              display: "flex",
                                              justifyContent: "space-between",
                                              gap: "30px",
                                            }}
                                            // className="d-flex justify-content-between"
                                          >
                                            <h5 className="fontSize">
                                              {valObj.label}
                                            </h5>
                                            <p className="fontSize">
                                              {isDateField
                                                ? formatDate(fieldVal)
                                                : fieldVal}
                                            </p>
                                          </div>
                                        );
                                      }
                                    )}
                                  </div>
                                </Fragment>
                              );
                            }
                            if (cplan?.carePlanType == "Contingency Plan") {
                              return (
                                <Fragment>
                                  <h5 className="fontSize mt-3">
                                    Contingency Plan
                                  </h5>
                                  <h5 className="fontSize mt-3">
                                    {" "}
                                    {cplan?.TemplateName}
                                  </h5>
                                  <p
                                    className="fontsmallText mb-0"
                                    style={{ fontSize: "14px" }}
                                  >
                                    Updated:{" "}
                                    {datechangeHandler(cplan?.last_update_date)}
                                  </p>
                                  <p
                                    className="fontsmallText"
                                    style={{ fontSize: "14px" }}
                                  >
                                    Updated By: {cplan?.updated_by}
                                  </p>

                                  <div className="col-md-8">
                                    {ContingencyDataLabelValues.map(
                                      (valObj, vIndx) => {
                                        const fieldVal = valObj.objkey
                                          ? cplan?.[valObj.objkey]?.[
                                              valObj?.value
                                            ]
                                          : cplan?.[valObj?.value];
                                        const isDateField =
                                          valObj.label.includes("date") ||
                                          valObj.label.includes("Date");
                                        return (
                                          <Fragment key={vIndx}>
                                            {valObj.head && (
                                              <h5 className="fontSize my-3">
                                                {valObj.head}
                                              </h5>
                                            )}
                                            <div
                                              style={{
                                                display: "flex",
                                                justifyContent: "space-between",
                                                gap: "30px",
                                              }}
                                            >
                                              <h5 className="fontSize">
                                                {valObj.label}
                                              </h5>
                                              <p className="fontSize">
                                                {isDateField
                                                  ? formatDate(fieldVal)
                                                  : fieldVal}
                                              </p>
                                            </div>
                                          </Fragment>
                                        );
                                      }
                                    )}
                                  </div>
                                </Fragment>
                              );
                            }
                            if (
                              cplan?.carePlanType === "Additional Support Plan"
                            ) {
                              return (
                                <Fragment>
                                  <h5 className="fontSize mt-3">
                                    Additional Support Plan
                                  </h5>
                                  <h5 className="fontSize mt-3">
                                    {" "}
                                    {cplan?.TemplateName}
                                  </h5>
                                  <p
                                    className="fontsmallText mb-0"
                                    style={{ fontSize: "14px" }}
                                  >
                                    Updated:{" "}
                                    {datechangeHandler(cplan?.last_update_date)}
                                  </p>
                                  <p
                                    className="fontsmallText"
                                    style={{ fontSize: "14px" }}
                                  >
                                    Updated By: {cplan?.updated_by}
                                  </p>

                                  <div className="col-md-8 right">
                                    {additionalPlanLabelValues.map(
                                      (valObj, vIndx) => {
                                        const fieldVal = valObj.objkey
                                          ? cplan?.[valObj?.objkey]?.[
                                              valObj?.value
                                            ]
                                          : cplan?.[valObj?.value];
                                        const isDateField =
                                          valObj.label.includes("date") ||
                                          valObj.label.includes("Date");
                                        return (
                                          <Fragment key={vIndx}>
                                            {valObj.head && (
                                              <h5 className="fontSize my-3">
                                                {valObj.head}
                                              </h5>
                                            )}
                                            <div
                                              style={{
                                                display: "flex",
                                                justifyContent: "space-between",
                                                gap: "30px",
                                              }}
                                            >
                                              <h5 className="fontSize">
                                                {valObj.label}
                                              </h5>
                                              <p className="fontSize">
                                                {isDateField
                                                  ? formatDate(fieldVal)
                                                  : fieldVal}
                                              </p>
                                            </div>
                                          </Fragment>
                                        );
                                      }
                                    )}
                                  </div>
                                </Fragment>
                              );
                            }
                          })}
                        </div>
                      </Fragment>
                    )}
                  </>
                );
              } else {
                return (
                  <>
                    {categoryplan?.template?.length > 0 && (
                      <Fragment>
                        <hr></hr>
                        <div className="row">
                          <div className="col-md-12 mb-2">
                            <h5 className="text-dark fontSize">
                              <img className="me-2" alt="" src={categoryIcon} />
                              {categoryplan?.categoryName}
                            </h5>
                          </div>

                          {categoryplan?.template?.map((cplan) => {
                            return (
                              <Fragment>
                                <h5 className="fontSize mt-3">
                                  {" "}
                                  {cplan?.TemplateName}
                                </h5>
                                {categoryplan?.categoryType !==
                                  "Administrative" && (
                                  <ul className="catList mb-3 p-2 mt-3 justify-content-start align-items-center">
                                    <h6 className="mb-0">Risk Profile: </h6>
                                    {cplan?.risk_profile && (
                                      <li
                                        style={{
                                          backgroundColor:
                                            cplan?.risk_profile === "high"
                                              ? "#BE0C0C"
                                              : cplan?.risk_profile === "medium"
                                              ? "#D96A07"
                                              : "#7D7D7D",
                                        }}
                                      >
                                        {cplan?.risk_profile === "high"
                                          ? "High"
                                          : cplan?.risk_profile === "medium"
                                          ? "Medium"
                                          : "Low"}{" "}
                                        <br /> Risk
                                      </li>
                                    )}
                                  </ul>
                                )}
                                <p
                                  className="fontsmallText mb-0"
                                  style={{ fontSize: "14px" }}
                                >
                                  Updated:{" "}
                                  {datechangeHandler(cplan?.last_update_date)}
                                </p>
                                <p
                                  className="fontsmallText"
                                  style={{ fontSize: "14px" }}
                                >
                                  Updated By: {cplan?.updated_by}
                                </p>

                                <div className="col-md-12 right">
                                  <div className="row">
                                    <div className="col-md-12">
                                      <h5 className="fontSize">
                                        Observations, Needs and Comments
                                      </h5>
                                      <TextContentBox
                                        text={
                                          cplan?.obeservation_needs_comments
                                        }
                                      />
                                      <h5 className="fontSize mt-5">
                                        Outcomes
                                      </h5>
                                      <TextContentBox text={cplan?.outcomes} />
                                      <h5 className="fontSize mt-5">
                                        Strength
                                      </h5>
                                      <TextContentBox text={cplan?.strength} />
                                      <h5 className="fontSize mt-5">Wishes</h5>
                                      <TextContentBox text={cplan?.wishes} />
                                    </div>

                                    {cplan?.Task?.length > 0 && (
                                      <div className="col-md-12 mb-3">
                                        <div className="d-flex fontSize">
                                          <div className={`col-md-2`}>
                                            <h5 className="fontSize">Task</h5>
                                          </div>
                                          <div className="col-4 ms-3">
                                            <h5 className="fontSize">
                                              Description
                                            </h5>
                                          </div>
                                          <div className="col-3 ms-3">
                                            <h5 className="fontSize">
                                              {" "}
                                              Start Time
                                            </h5>
                                          </div>
                                          <div className="col-3 ms-3">
                                            <h5 className="fontSize">
                                              {" "}
                                              End Time
                                            </h5>
                                          </div>
                                        </div>

                                        {cplan?.Task?.map((tObj, index) => {
                                          return (
                                            <div
                                              key={index}
                                              className="d-flex fontSize"
                                            >
                                              <div className="col-2">
                                                <span>{tObj?.taskType}</span>
                                              </div>
                                              <div className="col-4 ms-3">
                                                <span>
                                                  {tObj?.comments === ""
                                                    ? "-"
                                                    : tObj?.comments}
                                                </span>
                                              </div>
                                              <div className="col-3 ms-3">
                                                <span>
                                                  {tObj?.startTime === ""
                                                    ? "-"
                                                    : tObj?.startTime}
                                                </span>
                                              </div>
                                              <div className="col-3 ms-3">
                                                <span>
                                                  {tObj?.endTime === ""
                                                    ? "-"
                                                    : tObj?.endTime}
                                                </span>
                                              </div>
                                            </div>
                                          );
                                        })}
                                      </div>
                                    )}

                                    {cplan?.risk_interventions?.length > 0 && (
                                      <div className="col-md-12 mb-3">
                                        <div className="d-flex fontSize">
                                          <div className={`col-md-6`}>
                                            <h5 className="fontSize">Risks</h5>
                                          </div>
                                          <div className="col-md-6 ms-3">
                                            <h5 className="fontSize">
                                              Interventions
                                            </h5>
                                          </div>
                                        </div>

                                        {cplan?.risk_interventions?.map(
                                          (item, index) => {
                                            return (
                                              <div
                                                key={index}
                                                className="d-flex fontSize"
                                              >
                                                <div className="col-md-6">
                                                  <span>{item?.risk}</span>
                                                </div>
                                                <div className="col-md-6 ms-3">
                                                  <span>
                                                    {item?.interventions}
                                                  </span>
                                                </div>
                                              </div>
                                            );
                                          }
                                        )}
                                      </div>
                                    )}

                                    {cplan?.Safeguarding?.length > 0 && (
                                      <div className="col-md-12 mb-3">
                                        <div className="row fontSize">
                                          <div className={`col-sm-2`}>
                                            <h5 className="fontSize">
                                              Safeguarding Concern
                                            </h5>
                                          </div>
                                          <div className="col-sm-2">
                                            <h5 className="fontSize">
                                              Crime reference number
                                            </h5>
                                          </div>
                                          <div className="col-sm-2">
                                            <h5 className="fontSize">
                                              GP informed
                                            </h5>
                                          </div>
                                          <div className="col-sm-2">
                                            <h5 className="fontSize">
                                              Police aware
                                            </h5>
                                          </div>
                                          <div className="col-sm-2">
                                            <h5 className="fontSize">
                                              Safeguarding concerns start date
                                            </h5>
                                          </div>
                                          <div className="col-sm-2">
                                            <h5 className="fontSize">
                                              Safeguarding concerns end date
                                            </h5>
                                          </div>
                                        </div>

                                        {cplan?.Safeguarding?.map(
                                          (item, index) => {
                                            return (
                                              <div
                                                key={index}
                                                className="row fontSize"
                                              >
                                                <div className="col-sm-2">
                                                  <span>
                                                    {item?.safeguardingConcern}
                                                  </span>
                                                </div>
                                                <div className="col-sm-2">
                                                  <span>
                                                    {item?.crimeRefNumber}
                                                  </span>
                                                </div>
                                                <div className="col-sm-2">
                                                  <span>
                                                    {item?.gpInformed}
                                                  </span>
                                                </div>
                                                <div className="col-sm-2">
                                                  <span>
                                                    {item?.policeAware}
                                                  </span>
                                                </div>
                                                <div className="col-sm-2">
                                                  <span>
                                                    {formatDate(
                                                      item?.safeguardingStartDate
                                                    )}
                                                  </span>
                                                </div>
                                                <div className="col-sm-2">
                                                  <span>
                                                    {formatDate(
                                                      item?.safeguardingEndDate
                                                    )}
                                                  </span>
                                                </div>
                                              </div>
                                            );
                                          }
                                        )}
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </Fragment>
                            );
                          })}
                        </div>
                      </Fragment>
                    )}
                  </>
                );
              }
            })}
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default PreviewCarePlan;

const TextContentBox = ({ text, mb = 0 }) => {
  return (
    <div>
      {text
        ? text?.split("\n").map((line, index) => (
            <p className={`fontSize mb-${mb}`} key={index}>
              {line}
            </p>
          ))
        : ""}
    </div>
  );
};

function orderByCategoryIndex(data) {
  const categoryOrder = {
    "Social & Communication": 1,
    "Personal Care": 2,
    Health: 3,
    "Mobility & Safety": 4,
    Diet: 5,
    Housekeeping: 6,
    Administrator: 7,
  };
  return data?.sort((a, b) => {
    const indexA = categoryOrder[a.categoryType] ?? Infinity; // If not found, assign Infinity
    const indexB = categoryOrder[b.categoryType] ?? Infinity;
    return indexA - indexB;
  });
}
